























import Vue from 'vue'
import TranslationDisplay from '../../components/base/Translation/TranslationDisplay.vue'
import LiftTitle from '../../components/Domain/Lift/LiftTitle.vue'
import LiftDescription from '../../components/Domain/Lift/LiftDescription.vue'
import LiftLinkBtn from '../../components/Domain/Lift/LiftLinkBtn.vue'
import BaseDescription from '../../components/base/BaseDescription.vue'
import Story from './Story.vue'

export default Vue.extend({
  name: 'Experience',
  components: { Story, BaseDescription, LiftLinkBtn, LiftDescription, LiftTitle, TranslationDisplay },
  props: {
    lift: {
      type: Object,
      required: true
    }
  }
})
